module.exports = __webpack_public_path__ + "static/media/email-marketing.cf7e371b.svg";